import { render, staticRenderFns } from "./datailsLog.vue?vue&type=template&id=5260a46a&"
import script from "./datailsLog.vue?vue&type=script&lang=js&"
export * from "./datailsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports